module.exports = __webpack_public_path__ + "media/ITIRUM_GAMEPLAY_CORRIDOR_COMPRESSED.00e63c01.mp4";